export const SORT_ORDER_DESC = 'desc';
export const SORT_ORDER_ASC = 'asc';

export const SORT_ORDERS = [SORT_ORDER_ASC, SORT_ORDER_DESC];

type SortDirection = typeof SORT_ORDER_DESC | typeof SORT_ORDER_ASC;

export type SortOrderDropdownVocabKey =
  | 'Matching answers'
  | 'Non-matching answers'
  | 'A-Z names'
  | 'Z-A names'
  | 'Newest application'
  | 'Oldest application'
  | 'Highest rating'
  | 'Lowest rating'
  | 'Relevance'
  | 'Search relevance';

export interface SortType {
  value: string;
  label: SortOrderDropdownVocabKey;
  apiKey: string;
  sortOrder: SortDirection;
}

export const SORT_ANSWERS_MATCHING: SortType = {
  value: 'matching-answers',
  label: 'Matching answers',
  apiKey: 'score',
  sortOrder: SORT_ORDER_DESC,
};

export const SORT_ANSWERS_NON_MATCHING: SortType = {
  value: 'non-matching-answers',
  label: 'Non-matching answers',
  apiKey: 'score',
  sortOrder: SORT_ORDER_ASC,
};

export const SORT_NAME_A_Z: SortType = {
  value: 'a-z-name',
  label: 'A-Z names',
  apiKey: 'name',
  sortOrder: SORT_ORDER_ASC,
};

export const SORT_NAME_Z_A: SortType = {
  value: 'z-a-name',
  label: 'Z-A names',
  apiKey: 'name',
  sortOrder: SORT_ORDER_DESC,
};

export const SORT_NEWEST_APPLICATION: SortType = {
  value: 'newest-application',
  label: 'Newest application',
  apiKey: 'applicationDate',
  sortOrder: SORT_ORDER_DESC,
};

export const SORT_OLDEST_APPLICATION: SortType = {
  value: 'oldest-application',
  label: 'Oldest application',
  apiKey: 'applicationDate',
  sortOrder: SORT_ORDER_ASC,
};

export const SORT_HIGH_RATING: SortType = {
  value: 'highest-rating',
  label: 'Highest rating',
  apiKey: 'rating',
  sortOrder: SORT_ORDER_DESC,
};

export const SORT_LOW_RATING: SortType = {
  value: 'lowest-rating',
  label: 'Lowest rating',
  apiKey: 'rating',
  sortOrder: SORT_ORDER_ASC,
};

// deep match relevance
export const SORT_RELEVANCE: SortType = {
  label: 'Relevance',
  value: 'relevance',
  apiKey: 'relevance',
  sortOrder: SORT_ORDER_DESC,
};

// search relevance - only used when in search mode -
// should never appear in sort list
export const SORT_SEARCH_RELEVANCE: SortType = {
  label: 'Search relevance',
  value: 'search-relevance',
  apiKey: 'searchRelevance',
  sortOrder: SORT_ORDER_DESC,
};

export const DEFAULT_SORT_OPTION = SORT_ANSWERS_MATCHING;

export const SORT_OPTIONS = [
  SORT_RELEVANCE,
  SORT_ANSWERS_MATCHING,
  SORT_ANSWERS_NON_MATCHING,
  SORT_NAME_A_Z,
  SORT_NAME_Z_A,
  SORT_NEWEST_APPLICATION,
  SORT_OLDEST_APPLICATION,
  SORT_HIGH_RATING,
  SORT_LOW_RATING,
  SORT_SEARCH_RELEVANCE,
];

export const COMMON_SORT_OPTIONS = [
  SORT_HIGH_RATING,
  SORT_LOW_RATING,
  SORT_NAME_A_Z,
  SORT_NAME_Z_A,
  SORT_NEWEST_APPLICATION,
  SORT_OLDEST_APPLICATION,
];
